<template>
  <carousel
    pagination-color="#6f707b"
    pagination-active-color="#3139f2"
    :scroll-per-page="true"
    :per-page-custom="[
      [240, 1],
      [640, 2],
      [1200, 3]
    ]"
  >
    <slot></slot>
  </carousel>
</template>
<style>
.VueCarousel-pagination {
  margin-top: -50px;
}
</style>
<script>
import { Carousel } from 'vue-carousel'

export default {
  components: {
    Carousel
  }
}
</script>
